import type { StartEmailMfaEnrollmentRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useStartEmailMfaEnrollment() {
  return useApiMutation("post", "/auth/mfa/email/setup", {
    notify: false,
    mapVariables: (body: StartEmailMfaEnrollmentRequestDto) => ({ body }),
  });
}
